'use strict';

import moment from "moment-timezone";

export default {
    methods: {
        showTimeLeftBeforeEvent() {
            let count;

            this.eventDate = moment(this.eventDate);

            const countdown = () => {
                const dateNow = moment.tz('America/New_York');
                const timeLeft = this.eventDate.unix() - dateNow.unix();
                const date = moment.duration(timeLeft * 1000, 'milliseconds');

                this.types.days = date.asDays() | 0,
                    this.types.hours = date.hours() | 0,
                    this.types.minutes = date.minutes() | 0,
                    this.types.seconds = date.seconds() | 0;

                const type = Object.keys(this.types);

                type.forEach((type, index) => {
                    let obj = {label: `${type}`, type: parseInt(`${this.types[type]}`)};
                    this.getCountdownLabel(obj);
                });

                if (timeLeft <= 0) {
                    clearInterval(count);

                    if (this.countStarted) {
                        this.countdownFinished = true;
                        this.$root.$emit('countdown-ended');
                    }
                } else {
                    this.countStarted = true;
                }
            };

            count = setInterval(countdown, 1000);
        }
    }
};